<div class="m-header-menu">
    <div class="m-header-menu__icon">
        <ui-icon-bs [fontSize]="1.8" [type]="bsIconTypes.List"
                    [pseudo]="'white'"
                    [ariaExpanded]="isOpen"
                    [ariaControls]="menuId"
                    [titleText]="'aria-label.openMenu' | translate"
                    [ariaLabel]="'aria-label.openMenu' | translate"
                    (handlerClick)="open()" />
    </div>
</div>

@if (isOpen) {
    <div class="m-header-menu__modal position-fixed"
         role="dialog"
         aria-modal="true"
         cdkTrapFocus
         [attr.aria-label]="'aria-label.menu' | translate"
         [cdkTrapFocusAutoCapture]="true"
         [id]="menuId"
         (keydown.escape)="close()">
        <div class="container-fluid">
            <div class="row flex-row justify-content-between align-items-center m-header-menu__header">
                <div class="col px-md-8">
                    <div class="m-header-menu__icon d-flex">
                        <ui-icon-bs [fontSize]="1.8"
                                    [type]="bsIconTypes.XLg"
                                    [titleText]="'aria-label.closeMenu' | translate"
                                    [ariaLabel]="'aria-label.closeMenu' | translate"
                                    [pseudo]="'black'" (handlerClick)="close()" />
                    </div>
                </div>

                <div class="col">
                    <div class="m-header-menu__user-card mt-2">
                        <div class="m-header-menu__user-name">{{ user.usrName.substring(0, 1) }}.&nbsp;{{ user.surname }}</div>
                        <div class="m-header-menu__user-org" [innerHTML]="user?.orgName | safeHtml"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid mt-10">
            <div class="row">
                @for (item of menuItems; track item.mdId) {
                    <div class="col-12 text-center mb-2">
                        <a class="a--border-off m-header-menu__link" rel="noopener" target="_blank" [href]="item.url | currentProtocol">{{
                            item.mdName
                        }}</a>
                    </div>
                }
                <div class="col-12 text-center mb-2">
                    <a class="a--border-off m-header-menu__link" [href]="routeEntity.Root + routeEntity.UserSettings">
                        {{ 'global.labels.settings' | translate }}
                    </a>
                </div>
                <div class="col-12 text-center">
                    <a class="a--border-off m-header-menu__link" [href]="routeEntity.Root + routeEntity.Logout">
                        {{ 'global.actions.logout' | translate }}
                    </a>
                </div>
            </div>
        </div>
    </div>
}
